<template>
    <div class="waitingMessage">
        <div class="d-flex">
            <i v-if="message.icon" :class="message.icon" class="waiting-icon"></i>
            <div v-if="message.type==='initialmessage'">
                <div v-html="message.label"></div>
                <type-chat
                    v-for="type in message.desc"
                    v-bind:key="type.id"
                    v-bind:type="type">
                </type-chat>
            </div>
            <div v-if="message.type==='message'">
                <div v-html="message.label"></div>
                <div v-html="message.desc" :class="message.descClass"></div>
            </div>
            <div v-else-if="message.type==='action'">
                <div v-html="message.label"></div>
                <div v-html="message.desc"></div>
                <div class="action-wrapper">
                    <input :placeholder="$gettext('Déjanos tu número de móvil')">
                    <div class="icon-wrapper">
                        <i class="input-icon icon-chevron-right"></i>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import TypeChat from './TypeChat.vue'

export default {
    name: 'WaitingMessage',
    components: {
        TypeChat
    },
    props: ['message']
}
</script>
